import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { AppImage } from '../AppImage';
import type { Project } from '../../types/content';
interface WorkCardProps {
  project: Project;
  layout: 'featured' | 'standard';
}
function Tags({
  tags
}: {
  tags: string[];
}) {
  return <ul className="mt-6 flex flex-wrap gap-2" data-id="element-887" data-mp="gm3btvtaufyh">
      {tags.map(tag => <li key={tag} className="rounded-full border border-hairline px-3 py-1 text-[12px] leading-5 text-muted" data-id="element-888" data-mp="3f5a9tsis1cgo">
          {tag}
        </li>)}
    </ul>;
}
export function WorkCard({
  project,
  layout
}: WorkCardProps) {
  const isFeatured = layout === 'featured';
  return <Link to={`/work/${project.slug}`} className={`group block focus-visible:outline-none ${isFeatured ? 'lg:grid lg:grid-cols-12 lg:items-center lg:gap-12' : ''}`} data-id="element-889" data-mp="3tuq0l8ib5hwd">
      <AppImage src={project.image} alt={project.alt} ratio="4:3" className={isFeatured ? 'lg:col-span-7' : ''} imageClassName="transition-transform duration-500 ease-editorial group-hover:scale-[1.03] group-focus-visible:scale-[1.03]" data-id="element-890" data-mp="31cbyuxtupbs0" />

      <div className={isFeatured ? 'mt-8 lg:col-span-5 lg:mt-0' : 'mt-7'} data-id="element-891" data-mp="2tf55yj9me65c">
        {project.isConcept && <p className="mb-3 text-[12px] uppercase tracking-[0.06em] text-[#6E6E6E]" data-id="element-892" data-mp="2pev0r8tnjjrj">
            Self-initiated concept
          </p>}
        <p className="text-small text-muted" data-id="element-893" data-mp="2kcvxs01tqov4">
          {project.client} <span aria-hidden="true" data-id="element-894" data-mp="2feujrtj99fqi">·</span> {project.clientType}
        </p>
        <h3 className={`mt-3 leading-[1.2] tracking-[-0.025em] text-ink ${isFeatured ? 'max-w-[22ch] text-[32px] lg:text-[40px]' : 'max-w-[26ch] text-[24px]'}`} data-id="element-895" data-mp="2ag9gtmcmchyd">
          {project.headline}
        </h3>
        <p className={`mt-4 text-body text-muted ${isFeatured ? 'max-w-[46ch]' : 'max-w-[42ch]'}`} data-id="element-896" data-mp="8omw22jbljac">
          {project.problem}
        </p>

        <p className="mt-6 flex items-baseline justify-between gap-5 border-t border-hairline pt-5" data-id="element-897" data-mp="1y6tifs5ouwqj">
          <span className="max-w-[28ch] text-small font-medium leading-6 text-ink" data-id="element-898" data-mp="22x087vbxsnad">
            {project.outcome}
          </span>
          <span className="shrink-0 text-small text-muted" data-id="element-899" data-mp="1p6wszobh5tuf">{project.year}</span>
        </p>

        <Tags tags={project.tags} data-id="element-900" data-mp="1t8iaxo2v8ybh" />

        <span className="mt-7 inline-flex items-center gap-2 text-small text-accent transition-colors duration-150 ease-out group-hover:text-ink group-focus-visible:text-ink" data-id="element-901" data-mp="1t5dy62bc4u97">
          Read the case study
          <ArrowUpRightIcon size={16} aria-hidden="true" className="transition-transform duration-200 ease-editorial group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-902" data-mp="2lu1ls4jk3vpx" />
        </span>
      </div>
    </Link>;
}